import { Component, OnInit } from '@angular/core';
import { ConcessaoSituacao, ConcessaoSituacaoLabels } from '@tivic-team/manager-ts/dist/mob/enums/concessao-situacao.enum';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'dropdown-situacao-concessao',
  templateUrl: './dropdown-situacao-concessao.component.html',
  styleUrls: ['./dropdown-situacao-concessao.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class DropdownSituacaoConcessaoComponent implements OnInit {

  tipoSituacao = ConcessaoSituacaoLabels;

  constructor() { }

  ngOnInit() { }

  public selectedAtivo = this.tipoSituacao[ConcessaoSituacao.ATIVO];

}
